import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "How do you ensure my property stays in pristine condition?",
  answer: "We utilize an advanced tech-stack for 24/7 maintenance coordination and professional cleaning schedules. Our local teams conduct regular inspections, ensuring your 'nest' is always guest-ready and meticulously maintained without you lifting a finger."
}, {
  question: "What is the difference between your STR and MTR management?",
  answer: "Short-term rentals (STR) maximize nightly rates through dynamic pricing, while mid-term rentals (MTR) provide stability through our network of corporate and insurance housing. We strategically blend both strategies to optimize your annual revenue and occupancy."
}, {
  question: "How transparent is the management process for owners?",
  answer: "Completely. You'll have access to a dedicated owner portal featuring real-time data on bookings, revenue, and guest feedback. We believe in total transparency, ensuring you are always informed while remaining entirely hands-off."
}, {
  question: "How do you handle guest screening and security?",
  answer: "Security is our priority. We use AI-driven guest screening tools to verify identities and prevent issues before they happen. Every stay is backed by comprehensive insurance coverage and our own strict house rules to protect your investment."
}, {
  question: "What does 'full-service management' actually include?",
  answer: "It means you are 100% hands-off. We handle listing optimization, guest communication, professional photography, maintenance, laundry, and financial reporting. We take care of the rest so you can simply enjoy the results."
}];
export default function CommonQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}